import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			breadcrumb: 'GB WhatsApp',
			appname: 'GBWhatsApp',
			title: `GB WhatsApp|Download GBWhatsApp APK Latest Version 2026`,
			keywords: 'GB WhatsApp, GB WhatsApp Download',
			description: `Download GB WhatsApp APK Latest Version 2026 for Android. Get the updated GBWhatsApp with enhanced privacy, customization options, and safe installation from a trusted source.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			breadcrumb: 'Download',
			appname: 'GBWhatsApp',
			title: `Download GBWhatsApp APK v18.80 - Free & Safe`,
			keywords: 'Download GB WhatsApp, Download GB WhatsApp APK',
			description: `Download GBWhatsApp APK v18.80 free for Android 5.0+. Lightweight file, fast installation, and easy setup. Get the latest GBWhatsApp 2026 version safely.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/fm-whatsapp/',
		name: 'en-fm-whatsapp',
		meta: {
			breadcrumb: 'FM WhatsApp',
			appname: 'FM WhatsApp',
			title: `FM WhatsApp Download APK – Latest Version 2026`,
			keywords: 'FM WhatsApp, FM WhatsApp APK, FMWhatsApp Download',
			description: `Download FM WhatsApp APK latest version 2026 for Android. Explore features, compare with GB WhatsApp, and get the full guide to install FMWhatsApp safely.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/fm-whatsapp/'
				}
			]
		},
		component: () => import('@/views/fm-whatsapp.vue'),
	},
	{
		path: '/jt-whatsapp/',
		name: 'en-jt-whatsapp',
		meta: {
			breadcrumb: 'JT WhatsApp',
			appname: 'JT WhatsApp',
			title: `JT WhatsApp Download APK – Latest Version 2026`,
			keywords: 'JT WhatsApp, JT WhatsApp APK, JTWhatsApp Download',
			description: `Download JT WhatsApp APK 2026 for Android. A lightweight, stable WhatsApp MOD with privacy controls and dual account support. Compare JT WhatsApp vs GB WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/jt-whatsapp/'
				}
			]
		},
		component: () => import('@/views/jt-whatsapp.vue'),
	},
	{
		path: '/yo-whatsapp/',
		name: 'en-yo-whatsapp',
		meta: {
			breadcrumb: 'YoWhatsApp',
			appname: 'YoWhatsApp',
			title: `YoWhatsApp Download APK – Latest Version 2026`,
			keywords: 'YoWhatsApp, Yo WhatsApp APK, YoWA Download 2026',
			description: `Download YoWhatsApp APK latest version 2026. Explore themes, freeze last seen, anti-delete, and extended status features. Full YoWhatsApp vs GB WhatsApp comparison inside.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/yo-whatsapp/'
				}
			]
		},
		component: () => import('@/views/yo-whatsapp.vue'),
	},
	{
		path: '/og-whatsapp/',
		name: 'en-og-whatsapp',
		meta: {
			breadcrumb: 'OG WhatsApp',
			appname: 'OG WhatsApp',
			title: `OG WhatsApp Download APK – Latest Version 2026`,
			keywords: 'OG WhatsApp, OG WhatsApp APK, OGWhatsApp Download',
			description: `Download OG WhatsApp APK 2026 for Android. Learn about this classic WhatsApp MOD's features, its history, and how it compares to GB WhatsApp today.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/og-whatsapp/'
				}
			]
		},
		component: () => import('@/views/og-whatsapp.vue'),
	},
	{
		path: '/red-whatsapp/',
		name: 'en-red-whatsapp',
		meta: {
			breadcrumb: 'Red WhatsApp',
			appname: 'Red WhatsApp',
			title: `Red WhatsApp Download APK – Latest Version 2026`,
			keywords: 'Red WhatsApp, Red WhatsApp APK, WhatsApp Rouge Download',
			description: `Download Red WhatsApp APK 2026 for Android. Discover this bold red-themed WhatsApp MOD's features, animations, privacy controls, and how it differs from GB WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/red-whatsapp/'
				}
			]
		},
		component: () => import('@/views/red-whatsapp.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'en-privacy-policy',
		meta: {
			breadcrumb: 'Privacy Policy',
			appname: 'GBWhatsApp',
			title: 'Privacy Policy | GB WhatsApp Information Site',
			keywords: 'GB WhatsApp, privacy policy, cookies, analytics',
			description:
				'Read the privacy policy for our independent GB WhatsApp informational website, including cookies, analytics, and user data practices.',
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/privacy-policy/',
				},
			],
		},
		component: () => import('@/views/privacy-policy.vue'),
	},
	{
		path: '/contact/',
		name: 'en-contact',
		meta: {
			breadcrumb: 'Contact Us',
			appname: 'GBWhatsApp',
			title: 'Contact Us | GB WhatsApp Information Site',
			keywords: 'GB WhatsApp, contact, support, feedback',
			description:
				'Contact our team for questions, feedback, corrections, or copyright concerns related to this GB WhatsApp informational website.',
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/contact/',
				},
			],
		},
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/about/',
		name: 'en-about',
		meta: {
			breadcrumb: 'About Us',
			appname: 'GBWhatsApp',
			title: 'About Us | Independent GB WhatsApp Resource',
			keywords: 'GB WhatsApp, about us, guides, tutorials',
			description:
				'Learn more about our independent website dedicated to GB WhatsApp guides, tutorials, updates, and educational information.',
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/about/',
				},
			],
		},
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			breadcrumb: 'Disclaimer',
			appname: 'GBWhatsApp',
			title: 'Disclaimer & Compliance | GB WhatsApp Information Website',
			keywords: 'GB WhatsApp, disclaimer, compliance, trademark',
			description:
				'Read the disclaimer and compliance information for this independent GB WhatsApp informational website.',
			link: [
				{
					rel: 'canonical',
					href: 'https://appsgb.org/disclaimer/',
				},
			],
		},
		component: () => import('@/views/disclaimer.vue'),
	},

]


let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
